#import '../queries/UserDetails.graphql'
mutation Login($username: String!, $password: String!) {
  login(username: $username, password: $password) {
    ok
    errors
    sessionid
    user {
      ...userDetails
    }
  }
}
